import React from 'react';

const Loading = () => {
  return (
    <div className="loading">
      {/* Empty screen */}
    </div>
  );
};

export default Loading;